import React, { useState, useEffect, ReactNode } from "react";
import { Typography, Divider, Icon, Button, Table } from "antd";
import TicketService, { TicketModel, TicketStatus } from "services/http/endpoints/tickets";
import { isEmpty } from "lodash";
import jMoment from "moment-jalaali";
import CreateTicket from "./components/tickets/CreateTicket";
import { NavLink } from "react-router-dom";
// import useStock from "hooks/useStock";
import { get } from 'lodash';
import { inject, observer } from 'mobx-react';
import { FormComponentProps } from "antd/lib/form";
import UserStore from 'state/user';
import styles from "./index.module.scss";

const { Text, Title } = Typography;

interface IProps extends FormComponentProps {
	user: UserStore;
	children?: ReactNode;
}

const Tickets = (props: IProps) => {
	const [loading, setLoading] = useState(false);
	const [showCreateModal, setShowCreateModal] = useState(false);
	const [pagination, setPagination] = useState();
	const [tickets, setTickets] = useState([] as TicketModel[]);
	const [ticketsCategories, setTicketCategories] = useState([]);

	const fetchConfigs = async () => {
		const configs = await props.user.baazarConfigs;
		let ticketsConfig = get(configs, ["TICKET_CATEGORY"]);
		if (ticketsConfig !== undefined) {
			ticketsConfig = ticketsConfig.split('#');
			setTicketCategories(ticketsConfig);
		}
	}

	const fetchData = async (params?: any) => {
		try {
			// eslint-disable-next-line array-callback-return
			setLoading(true);
			TicketService.clearOrder();
			TicketService.clearFilter();
			TicketService.size = params.size;
			TicketService.page = params.page;
			TicketService.makeOrderBy("createdDate", false);
			if (typeof params.filters === "object") {
				Object.keys(params.filters).map(key => {
					if (params.filters[key].length > 0) {
						TicketService.makeFilters(key, "IN", params.filters[key].join());
					}
				});
			}
			const res = await TicketService.search(TicketService.getSearchFilter());
			// console.log(res);
			const pager = { ...pagination };
			// Read total count from server
			pager.total = res.data.pagination.total;
			setLoading(false);
			setPagination(pager);
			setTickets(res.data.result);
		} catch (error) {
			setLoading(false);
		}
	}

	useEffect(() => {
		fetchConfigs();
		fetchData({ size: 10, page: 1 });
	}, []);

	function onFinishModal() {
		setShowCreateModal(false);
		fetchData({ size: 10, page: 1 });
	}

	function onCloseModal() {
		setShowCreateModal(false);
	}

	function onOpenModal() {
		setShowCreateModal(true);
	}

	function ticketStatusFormatted(status: string) {
		switch (status) {
			case TicketStatus.IN_PROGRESS:
				return (
					<Text>
						<Icon type="clock-circle" /> در حال بررسی
					</Text>
				);
			case TicketStatus.CLOSED:
				return (
					<Text type="danger">
						<Icon type="close-circle" /> بسته شده
					</Text>
				);
			case TicketStatus.NEW:
				return (
					<Text style={{ color: "#0b8235" }}>
						<Icon type="check-circle" /> جدید
					</Text>
				);

			case TicketStatus.USER_REPLY:
				return (
					<Text>
						<Icon type="check-circle" /> پاسخ کاربر
					</Text>
				);
			default:
				return "پاسخ اپراتور";
		}
	}

	function handleTableChange(_pagination: any, filters: any, sorter: any) {
		const pager = { ...pagination };
		pager.current = _pagination.current;
		setPagination({
			pagination: pager,
		});
		fetchData({
			size: _pagination.pageSize,
			page: _pagination.current,
			filters,
		});
	}

	const columns = [
		{
			title: "موضوع",
			dataIndex: "title",
			key: "title",
			render: (data: any) => {
				return <span>{data}</span>;
			},
		},
		{
			title: "دسته بندی",
			dataIndex: "category",
			key: "category",
			filters: ticketsCategories.map((c: string) => {
				return { text: c, value: c };
			}),
			render: (data: any) => {
				return <span><Text>{data}</Text></span>;
			},
		},
		{
			title: "وضعیت",
			dataIndex: "status",
			key: "status",
			filters: Object.keys(TicketStatus).map(value => {
				return { text: ticketStatusFormatted(value), value };
			}),
			render: (data: any) => {
				return <span>{ticketStatusFormatted(data)}</span>;
			},
		},
		{
			title: "تاریخ ثبت",
			dataIndex: "createdDate",
			key: "createdDate",
			render: (data: any) => {
				return <span dir={"ltr"}>{jMoment(data).format("jYYYY/jMM/jDD HH:mm")}</span>;
			},
		},
		{
			title: "",
			dataIndex: "id",
			key: "id",
			render: (data: string) => {
				return (
					<NavLink to={`tickets/${data}`}>
						<Button size="small" type="primary" shape="round">
							جزئیات
						</Button>
					</NavLink>
				);
			},
		},
	];

	return (
		<div className="container">
			<div className={styles["tickets"]}>
				<Title level={4}>
					<Icon type="tag" /> تیکت ها
					<Divider type="vertical" />
					<Button type="primary" shape="round" size="small" icon="plus" onClick={() => onOpenModal()}>
						تیکت جدید
					</Button>
				</Title>
				<Table
					columns={columns}
					loading={loading}
					bordered
					pagination={pagination}
					className={styles["table"]}
					onChange={handleTableChange}
					scroll={{ x: true, y: false }}
					dataSource={
						!isEmpty(tickets)
							? tickets.map((data: TicketModel, key: number) => ({
									id: data.id,
									user: data.user,
									status: data.status,
									title: data.title,
									lastModifiedDate: data.lastModifiedDate,
									createdDate: data.createdDate,
									category: data.category,
							  }))
							: []
					}
				/>
			</div>
			<CreateTicket categories={ticketsCategories} shouldVisible={showCreateModal} onClose={onCloseModal} onFinish={onFinishModal} />
		</div>
	);
};

export default inject("user")(observer(Tickets));
